// import React, { useState, useCallback, useEffect, useRef } from "react";
// import { FaTimes, FaRobot } from "react-icons/fa";
// import { useTypedSelector } from "@/hooks";
// import {
//   useFetchAISuggestionMessagesQuery,
//   usePostCompaRatioReviewMutation,
//   usePostCriticalPayPositioningMutation,
//   usePostPaymentRecommendationMutation,
//   usePostRetentionRiskMutation, // ✅ NEW
// } from "@/services/aiSuggestion2";
// import { getSelectedCompanyFromStorage } from "@/services/cookies";

// export function AISuggestionBot() {
//   const offerModellerData = useTypedSelector((state) => state.offers);

//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [hasNewNotification, setHasNewNotification] = useState(false);

//   const [insightsLoaded, setInsightsLoaded] = useState(false);

//   const [previousCompaParams, setPreviousCompaParams] = useState(null);
//   const [previousPaymentParams, setPreviousPaymentParams] = useState(null);
//   const [previousRetentionParams, setPreviousRetentionParams] = useState(null);

//   const messagesEndRef = useRef(null);
//   const scrollToBottom = () =>
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

//   const company_id = getSelectedCompanyFromStorage();
//   const offer_id = offerModellerData?.offer?.id;

//   // --------------------------------------------------------------------------
//   // EXTRACT OFFER MODELLER VALUES
//   // --------------------------------------------------------------------------
//   const offer_fixed_cash = offerModellerData?.offerModeller?.offer_fixed_cash;
//   const offer_sti = offerModellerData?.offerModeller?.offer_sti;
//   const offer_lti = offerModellerData?.offerModeller?.offer_lti;

//   const compa_ratio = offer_fixed_cash?.proposed_compa_ratio;
//   const market_ratio = offer_fixed_cash?.proposed_market_ratio;

//   const current_guaranteed_cash = offer_fixed_cash?.current_total ?? null;
//   const proposed_guaranteed_cash = offer_fixed_cash?.proposed_total ?? null;

//   const current_unvested_equity = offer_lti?.current_unvested_equity ?? null;

//   const current_total_target_cash =
//     (offer_fixed_cash?.current_total || 0) +
//     (offer_sti?.current_total_bonus || 0);

//   const proposed_total_target_cash = Math.round(
//     offer_sti?.is_sale_incentive &&
//       offer_fixed_cash?.proposed_annual_base &&
//       offer_sti?.proposed_base_pay_percentage
//       ? (offer_fixed_cash.proposed_annual_base *
//           ((offer_fixed_cash.proposed_annual_base *
//             (100 - offer_sti.proposed_base_pay_percentage)) /
//             100)) /
//           ((offer_fixed_cash.proposed_annual_base *
//             offer_sti.proposed_base_pay_percentage) /
//             100) -
//         offer_sti.proposed_base_pay_percentage +
//         ((offer_sti?.proposed_total_bonus || 0) +
//           (offer_fixed_cash?.proposed_total || 0))
//       : (offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0)
//   );

//   // --------------------------------------------------------------------------
//   // INSIGHTS API
//   // --------------------------------------------------------------------------
//   const { data: insightsData, isFetching: isFetchingInsights } =
//     useFetchAISuggestionMessagesQuery(
//       { company_id, offer_id },
//       { skip: !company_id || !offer_id }
//     );

//   // --------------------------------------------------------------------------
//   // MUTATIONS
//   // --------------------------------------------------------------------------
//   const [
//     triggerCompaRatio,
//     { data: compaData, isLoading: isFetchingCompa },
//   ] = usePostCompaRatioReviewMutation();

//   const [
//     triggerCriticalPay,
//     { data: criticalData, isLoading: isFetchingCritical },
//   ] = usePostCriticalPayPositioningMutation();

//   const [
//     triggerPaymentRecommendation,
//     { data: paymentData, isLoading: isFetchingPayment },
//   ] = usePostPaymentRecommendationMutation();

//   const [
//     triggerRetentionRisk,
//     { data: retentionData, isLoading: isFetchingRetention },
//   ] = usePostRetentionRiskMutation(); // ✅ NEW

//   // --------------------------------------------------------------------------
//   // PARAM DETECTION: COMPA + CRITICAL
//   // --------------------------------------------------------------------------
//   const compaAvailable = compa_ratio != null && market_ratio != null;
//   const compaChanged =
//     compaAvailable &&
//     (previousCompaParams === null ||
//       previousCompaParams.compa_ratio !== compa_ratio ||
//       previousCompaParams.market_ratio !== market_ratio);

//   // --------------------------------------------------------------------------
//   // PARAM DETECTION: PAYMENT (independent)
//   // --------------------------------------------------------------------------
//   const paymentAvailable =
//     current_unvested_equity != null &&
//     current_total_target_cash != null &&
//     proposed_total_target_cash != null;

//   const paymentChanged =
//     paymentAvailable &&
//     (previousPaymentParams === null ||
//       previousPaymentParams.current_unvested_equity !==
//         current_unvested_equity ||
//       previousPaymentParams.current_total_target_cash !==
//         current_total_target_cash ||
//       previousPaymentParams.proposed_total_target_cash !==
//         proposed_total_target_cash);

//   // --------------------------------------------------------------------------
//   // PARAM DETECTION: RETENTION RISK (independent)
//   // --------------------------------------------------------------------------
//   const retentionAvailable =
//     current_total_target_cash != null &&
//     proposed_total_target_cash != null &&
//     current_guaranteed_cash != null &&
//     proposed_guaranteed_cash != null;

//   const retentionChanged =
//     retentionAvailable &&
//     (previousRetentionParams === null ||
//       previousRetentionParams.current_total_target_cash !==
//         current_total_target_cash ||
//       previousRetentionParams.proposed_total_target_cash !==
//         proposed_total_target_cash ||
//       previousRetentionParams.current_guaranteed_cash !==
//         current_guaranteed_cash ||
//       previousRetentionParams.proposed_guaranteed_cash !==
//         proposed_guaranteed_cash);

//   // --------------------------------------------------------------------------
//   // DEBOUNCE COMPA + CRITICAL
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     if (!compaChanged) return;

//     const handler = setTimeout(() => {
//       triggerCompaRatio({ company_id, offer_id, compa_ratio, market_ratio });
//       triggerCriticalPay({ company_id, offer_id, compa_ratio, market_ratio });
//     }, 600);

//     return () => clearTimeout(handler);
//   }, [compaChanged, compa_ratio, market_ratio]);

//   // --------------------------------------------------------------------------
//   // DEBOUNCE PAYMENT
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     if (!paymentChanged) return;

//     const handler = setTimeout(() => {
//       triggerPaymentRecommendation({
//         company_id,
//         offer_id,
//         current_unvested_equity,
//         current_total_target_cash,
//         proposed_total_target_cash,
//       });
//     }, 600);

//     return () => clearTimeout(handler);
//   }, [
//     paymentChanged,
//     current_unvested_equity,
//     current_total_target_cash,
//     proposed_total_target_cash,
//   ]);

//   // --------------------------------------------------------------------------
//   // DEBOUNCE RETENTION RISK
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     if (!retentionChanged) return;

//     const handler = setTimeout(() => {
//       triggerRetentionRisk({
//         company_id,
//         offer_id,
//         current_total_target_cash,
//         proposed_total_target_cash,
//         current_guaranteed_cash,
//         proposed_guaranteed_cash,
//       });
//     }, 600);

//     return () => clearTimeout(handler);
//   }, [
//     retentionChanged,
//     current_total_target_cash,
//     proposed_total_target_cash,
//     current_guaranteed_cash,
//     proposed_guaranteed_cash,
//   ]);

//   // --------------------------------------------------------------------------
//   // LOAD INSIGHTS ONCE
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     if (!insightsLoaded && insightsData?.data?.insights?.length > 0) {
//       const mapped = insightsData.data.insights.map((insight) => ({
//         id: `insight-${insight.id}`,
//         field: insight.alert_type?.replace(/_/g, " "),
//         content: insight.message,
//         timestamp: new Date(insight.created_at).getTime(),
//       }));

//       setMessages((prev) => [...prev, ...mapped]);
//       if (!isOpen) setHasNewNotification(true);
//       setInsightsLoaded(true);
//     }
//   }, [insightsData]);

//   // --------------------------------------------------------------------------
//   // APPEND API RESULTS (COMPA)
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     const api = compaData?.data;
//     if (!api) return;

//     const alertMsg = {
//       id: `compa-${Date.now()}`,
//       field: api.alert_type?.replace(/_/g, " "),
//       content: api.message,
//       timestamp: Date.now(),
//     };

//     const recs = api.recommendations?.map((r, i) => ({
//       id: `compa-rec-${Date.now()}-${i}`,
//       field: "Recommendation",
//       content: r,
//       timestamp: Date.now(),
//     }));

//     setMessages((prev) => [...prev, alertMsg, ...(recs || [])]);
//     if (!isOpen) setHasNewNotification(true);

//     setPreviousCompaParams({ compa_ratio, market_ratio });
//   }, [compaData]);

//   // --------------------------------------------------------------------------
//   // APPEND API RESULTS (CRITICAL)
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     const api = criticalData?.data;
//     if (!api) return;

//     const alertMsg = {
//       id: `critical-${Date.now()}`,
//       field: api.alert_type?.replace(/_/g, " "),
//       content: api.message,
//       timestamp: Date.now(),
//     };

//     const recs = api.recommendations?.map((r, i) => ({
//       id: `critical-rec-${Date.now()}-${i}`,
//       field: "Recommendation",
//       content: r,
//       timestamp: Date.now(),
//     }));

//     setMessages((prev) => [...prev, alertMsg, ...(recs || [])]);
//     if (!isOpen) setHasNewNotification(true);

//     setPreviousCompaParams({ compa_ratio, market_ratio });
//   }, [criticalData]);

//   // --------------------------------------------------------------------------
//   // APPEND PAYMENT RESULTS
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     const api = paymentData?.data;
//     if (!api) return;

//     const alertMsg = {
//       id: `payment-${Date.now()}`,
//       field: api.alert_type?.replace(/_/g, " "),
//       content: api.message,
//       timestamp: Date.now(),
//     };

//     const recs = api.recommendations?.map((r, i) => ({
//       id: `payment-rec-${Date.now()}-${i}`,
//       field: "Recommendation",
//       content: r,
//       timestamp: Date.now(),
//     }));

//     setMessages((prev) => [...prev, alertMsg, ...(recs || [])]);
//     if (!isOpen) setHasNewNotification(true);

//     setPreviousPaymentParams({
//       current_unvested_equity,
//       current_total_target_cash,
//       proposed_total_target_cash,
//     });
//   }, [paymentData]);

//   // --------------------------------------------------------------------------
//   // APPEND RETENTION RESULTS
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     const api = retentionData?.data;
//     if (!api) return;

//     const alertMsg = {
//       id: `retention-${Date.now()}`,
//       field: api.alert_type?.replace(/_/g, " "),
//       content: api.message,
//       timestamp: Date.now(),
//     };

//     const recs = api.recommendations?.map((r, i) => ({
//       id: `retention-rec-${Date.now()}-${i}`,
//       field: "Recommendation",
//       content: r,
//       timestamp: Date.now(),
//     }));

//     setMessages((prev) => [...prev, alertMsg, ...(recs || [])]);
//     if (!isOpen) setHasNewNotification(true);

//     setPreviousRetentionParams({
//       current_total_target_cash,
//       proposed_total_target_cash,
//       current_guaranteed_cash,
//       proposed_guaranteed_cash,
//     });
//   }, [retentionData]);

//   // --------------------------------------------------------------------------
//   // SCROLL ON NEW MESSAGES
//   // --------------------------------------------------------------------------
//   useEffect(() => {
//     scrollToBottom();
//   }, [
//     messages,
//     isFetchingCompa,
//     isFetchingCritical,
//     isFetchingPayment,
//     isFetchingRetention,
//     isFetchingInsights,
//   ]);

//   // --------------------------------------------------------------------------
//   // External add message
//   // --------------------------------------------------------------------------
//   const handleAddSuggestion = useCallback(
//     (field, text) => {
//       const msg = {
//         id: `msg-${Date.now()}`,
//         field,
//         content: text,
//         timestamp: Date.now(),
//       };
//       setMessages((prev) => [...prev, msg]);
//       if (!isOpen) setHasNewNotification(true);
//     },
//     [isOpen]
//   );

//   useEffect(() => {
//     window.__chatbotSuggestion = handleAddSuggestion;
//   }, [handleAddSuggestion]);

//   const handleOpen = () => {
//     setIsOpen((p) => !p);
//     setHasNewNotification(false);
//   };

//   const isTyping =
//     isFetchingInsights ||
//     isFetchingCompa ||
//     isFetchingCritical ||
//     isFetchingPayment ||
//     isFetchingRetention;

//   // --------------------------------------------------------------------------
//   // UI
//   // --------------------------------------------------------------------------
//   return (
//     <div className="fixed bottom-6 right-6 z-[99999] flex flex-col items-end gap-3">
//       {isOpen && (
//         <div className="w-96 h-96 bg-white dark:bg-slate-900 rounded-2xl shadow-xl border overflow-hidden flex flex-col">
//           <div className="flex items-center justify-between p-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
//             <h3 className="font-semibold text-sm">AI Suggestions</h3>
//             <button onClick={() => setIsOpen(false)} className="hover:bg-white/10 p-1 rounded-lg">
//               <FaTimes className="w-4 h-4" />
//             </button>
//           </div>

//           <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-slate-50 to-white dark:bg-slate-900 dark:to-slate-800">
//             {messages.length === 0 && !isTyping ? (
//               <div className="flex justify-center items-center h-full text-slate-400">
//                 Fill the form to see AI suggestions.
//               </div>
//             ) : (
//               <>
//                 {messages.map((msg) => (
//                   <div key={msg.id}>
//                     <div className="flex gap-2 mb-1 items-center">
//                       <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
//                         AI
//                       </div>
//                       <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
//                         {msg.field}
//                       </span>
//                     </div>

//                     <div className="ml-8 p-3 rounded-xl bg-white dark:bg-slate-800 border text-sm whitespace-pre-wrap">
//                       {msg.content}
//                     </div>
//                   </div>
//                 ))}

//                 {isTyping && (
//                   <div>
//                     <div className="flex gap-2 mb-1 items-center">
//                       <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
//                         AI
//                       </div>
//                       <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
//                         <div className="p-2 rounded-xl dark:bg-slate-800 border flex gap-1">
//                           <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce" />
//                           <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce delay-150" />
//                           <span className="w-2 h-2 bg-slate-400 rounded-full animate-bounce delay-300" />
//                         </div>
//                       </span>
//                     </div>
//                   </div>
//                 )}

//                 <div ref={messagesEndRef} />
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       <button
//         onClick={handleOpen}
//         className={`relative w-16 h-16 rounded-full flex items-center justify-center shadow-xl transition ${
//           isOpen
//             ? "bg-gradient-to-br from-indigo-500 to-purple-500"
//             : "bg-gradient-to-br from-indigo-600 to-purple-600"
//         }`}
//       >
//         <FaRobot className="w-7 h-7 text-white" />
//         {hasNewNotification && !isOpen && (
//           <span className="absolute top-2 right-2 w-3 h-3 rounded-full bg-red-500 animate-ping" />
//         )}
//       </button>
//     </div>
//   );
// }








// import React, { useState, useCallback, useEffect, useRef } from "react";
// import { FaTimes, FaRobot } from "react-icons/fa";
// import { useTypedSelector } from "@/hooks";
// import {
//   useFetchAISuggestionMessagesQuery,
//   usePostCompaRatioReviewMutation,
//   usePostCriticalPayPositioningMutation,
//   usePostPaymentRecommendationMutation,
//   usePostRetentionRiskMutation,
// } from "@/services/aiSuggestion2";
// import { getSelectedCompanyFromStorage } from "@/services/cookies";

// export function AISuggestionBot() {
//   const offerModellerData = useTypedSelector((state) => state.offers);

//   const [isOpen, setIsOpen] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [hasNewNotification, setHasNewNotification] = useState(false);
//   const [insightsLoaded, setInsightsLoaded] = useState(false);

//   // 🚀 important: this prevents all unwanted initial API calls
//   const [initialParams, setInitialParams] = useState(null);

//   const messagesEndRef = useRef(null);

//   const scrollToBottom = () =>
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

//   const company_id = getSelectedCompanyFromStorage();
//   const offer_id = offerModellerData?.offer?.id;

//   // -----------------------------------------------------
//   // Extract offer modeller values
//   // -----------------------------------------------------
//   const offer_fixed_cash = offerModellerData?.offerModeller?.offer_fixed_cash;
//   const offer_sti = offerModellerData?.offerModeller?.offer_sti;
//   const offer_lti = offerModellerData?.offerModeller?.offer_lti;

//   const compa_ratio = offer_fixed_cash?.proposed_compa_ratio;
//   const market_ratio = offer_fixed_cash?.proposed_market_ratio;

//   const current_guaranteed_cash = offer_fixed_cash?.current_total ?? null;
//   const proposed_guaranteed_cash = offer_fixed_cash?.proposed_total ?? null;

//   const current_unvested_equity = offer_lti?.current_unvested_equity ?? null;

//   const current_total_target_cash =
//     (offer_fixed_cash?.current_total || 0) +
//     (offer_sti?.current_total_bonus || 0);

//   const proposed_total_target_cash = Math.round(
//     offer_sti?.is_sale_incentive &&
//       offer_fixed_cash?.proposed_annual_base &&
//       offer_sti?.proposed_base_pay_percentage
//       ? (offer_fixed_cash.proposed_annual_base *
//         ((offer_fixed_cash.proposed_annual_base *
//           (100 - offer_sti.proposed_base_pay_percentage)) /
//           100)) /
//       ((offer_fixed_cash.proposed_annual_base *
//         offer_sti.proposed_base_pay_percentage) /
//         100) -
//       offer_sti.proposed_base_pay_percentage +
//       ((offer_sti?.proposed_total_bonus || 0) +
//         (offer_fixed_cash?.proposed_total || 0))
//       : (offer_sti?.proposed_total_bonus || 0) +
//       (offer_fixed_cash?.proposed_total || 0)
//   );

//   // -----------------------------------------------------
//   // INSIGHTS API
//   // -----------------------------------------------------
//   const { data: insightsData, isFetching: isFetchingInsights } =
//     useFetchAISuggestionMessagesQuery(
//       { company_id, offer_id },
//       { skip: !company_id || !offer_id }
//     );

//   // -----------------------------------------------------
//   // MUTATIONS
//   // -----------------------------------------------------
//   const [
//     triggerCompaRatio,
//     { data: compaData, isLoading: isFetchingCompa }
//   ] = usePostCompaRatioReviewMutation();

//   const [
//     triggerCriticalPay,
//     { data: criticalData, isLoading: isFetchingCritical }
//   ] = usePostCriticalPayPositioningMutation();

//   const [
//     triggerPaymentRecommendation,
//     { data: paymentData, isLoading: isFetchingPayment }
//   ] = usePostPaymentRecommendationMutation();

//   const [
//     triggerRetentionRisk,
//     { data: retentionData, isLoading: isFetchingRetention }
//   ] = usePostRetentionRiskMutation();

//   // -----------------------------------------------------
//   // Capture initial params ONCE (after values exist)
//   // -----------------------------------------------------
//   useEffect(() => {
//     if (
//       initialParams === null &&
//       compa_ratio != null &&
//       market_ratio != null &&
//       current_unvested_equity != null &&
//       current_total_target_cash != null &&
//       proposed_total_target_cash != null &&
//       current_guaranteed_cash != null &&
//       proposed_guaranteed_cash != null
//     ) {
//       setInitialParams({
//         compa_ratio,
//         market_ratio,
//         current_unvested_equity,
//         current_total_target_cash,
//         proposed_total_target_cash,
//         current_guaranteed_cash,
//         proposed_guaranteed_cash,
//       });
//     }
//   }, [
//     initialParams,
//     compa_ratio,
//     market_ratio,
//     current_unvested_equity,
//     current_total_target_cash,
//     proposed_total_target_cash,
//     current_guaranteed_cash,
//     proposed_guaranteed_cash,
//   ]);

//   // -----------------------------------------------------
//   // INSIGHTS loaded → mark ready for change detection
//   // -----------------------------------------------------
//   const initialLoadComplete = Boolean(initialParams && insightsLoaded);

//   // -----------------------------------------------------
//   // LOAD INSIGHTS ONCE
//   // -----------------------------------------------------
//   useEffect(() => {
//     if (!insightsLoaded && insightsData?.data?.insights?.length > 0) {
//       const mapped = insightsData.data.insights.map((insight) => ({
//         id: `insight-${insight.id}`,
//         field: insight.alert_type?.replace(/_/g, " "),
//         content: insight.message,
//         timestamp: new Date(insight.created_at).getTime(),
//       }));

//       setMessages((prev) => [...prev, ...mapped]);
//       if (!isOpen) setHasNewNotification(true);

//       setInsightsLoaded(true);
//     }
//   }, [insightsData]);

//   // -----------------------------------------------------
//   // CHANGE DETECTORS (compare with initialParams)
//   // -----------------------------------------------------
//   const compaChanged =
//     initialLoadComplete &&
//     initialParams &&
//     (compa_ratio !== initialParams.compa_ratio ||
//       market_ratio !== initialParams.market_ratio);

//   const paymentChanged =
//     initialLoadComplete &&
//     initialParams &&
//     (
//       current_unvested_equity !== initialParams.current_unvested_equity ||
//       current_total_target_cash !== initialParams.current_total_target_cash ||
//       proposed_total_target_cash !== initialParams.proposed_total_target_cash
//     );

//   const retentionChanged =
//     initialLoadComplete &&
//     initialParams &&
//     (
//       current_total_target_cash !== initialParams.current_total_target_cash ||
//       proposed_total_target_cash !== initialParams.proposed_total_target_cash ||
//       current_guaranteed_cash !== initialParams.current_guaranteed_cash ||
//       proposed_guaranteed_cash !== initialParams.proposed_guaranteed_cash
//     );

//   // -----------------------------------------------------
//   // TRIGGER COMPA + CRITICAL (debounced)
//   // -----------------------------------------------------
//   useEffect(() => {
//     if (!compaChanged) return;

//     const t = setTimeout(() => {
//       triggerCompaRatio({ company_id, offer_id, compa_ratio, market_ratio });
//       triggerCriticalPay({ company_id, offer_id, compa_ratio, market_ratio });
//     }, 600);

//     return () => clearTimeout(t);
//   }, [compaChanged, compa_ratio, market_ratio]);

//   // -----------------------------------------------------
//   // TRIGGER PAYMENT (debounced)
//   // -----------------------------------------------------
//   useEffect(() => {
//     if (!paymentChanged) return;

//     const t = setTimeout(() => {
//       triggerPaymentRecommendation({
//         company_id,
//         offer_id,
//         current_unvested_equity,
//         current_total_target_cash,
//         proposed_total_target_cash,
//       });
//     }, 600);

//     return () => clearTimeout(t);
//   }, [
//     paymentChanged,
//     current_unvested_equity,
//     current_total_target_cash,
//     proposed_total_target_cash,
//   ]);

//   // -----------------------------------------------------
//   // TRIGGER RETENTION RISK (debounced)
//   // -----------------------------------------------------
//   useEffect(() => {
//     if (!retentionChanged) return;

//     const t = setTimeout(() => {
//       triggerRetentionRisk({
//         company_id,
//         offer_id,
//         current_total_target_cash,
//         proposed_total_target_cash,
//         current_guaranteed_cash,
//         proposed_guaranteed_cash,
//       });
//     }, 600);

//     return () => clearTimeout(t);
//   }, [
//     retentionChanged,
//     current_total_target_cash,
//     proposed_total_target_cash,
//     current_guaranteed_cash,
//     proposed_guaranteed_cash,
//   ]);

//   // -----------------------------------------------------
//   // Append results (ALL 4 APIs)
//   // -----------------------------------------------------
//   const appendApiResponse = (api, prefix) => {
//     if (!api?.data) return;

//     const alertMsg = {
//       id: `${prefix}-${Date.now()}`,
//       field: api.data.alert_type?.replace(/_/g, " "),
//       content: api.data.message,
//       timestamp: Date.now(),
//     };

//     const recs =
//       api.data.recommendations?.map((r, i) => ({
//         id: `${prefix}-rec-${Date.now()}-${i}`,
//         field: "Recommendation",
//         content: r,
//         timestamp: Date.now(),
//       })) || [];

//     setMessages((prev) => [...prev, alertMsg]);
//     // setMessages((prev) => [...prev, alertMsg, ...recs]);
//     if (!isOpen) setHasNewNotification(true);
//   };

//   useEffect(() => appendApiResponse(compaData, "compa"), [compaData]);
//   useEffect(() => appendApiResponse(criticalData, "critical"), [criticalData]);
//   useEffect(() => appendApiResponse(paymentData, "payment"), [paymentData]);
//   useEffect(() => appendApiResponse(retentionData, "retention"), [retentionData]);

//   // -----------------------------------------------------
//   // AUTO SCROLL
//   // -----------------------------------------------------
//   useEffect(() => {
//     scrollToBottom();
//   }, [
//     messages,
//     isFetchingCompa,
//     isFetchingCritical,
//     isFetchingPayment,
//     isFetchingRetention,
//     isFetchingInsights,
//   ]);

//   // -----------------------------------------------------
//   // External add message
//   // -----------------------------------------------------
//   const handleAddSuggestion = useCallback(
//     (field, text) => {
//       const msg = {
//         id: `msg-${Date.now()}`,
//         field,
//         content: text,
//         timestamp: Date.now(),
//       };
//       setMessages((prev) => [...prev, msg]);
//       if (!isOpen) setHasNewNotification(true);
//     },
//     [isOpen]
//   );

//   // exposure
//   useEffect(() => {
//     window.__chatbotSuggestion = handleAddSuggestion;
//   }, [handleAddSuggestion]);

//   const handleOpen = () => {
//     setIsOpen((p) => !p);
//     setHasNewNotification(false);
//   };

//   const isTyping =
//     isFetchingInsights ||
//     isFetchingCompa ||
//     isFetchingCritical ||
//     isFetchingPayment ||
//     isFetchingRetention;

//   // -----------------------------------------------------
//   // UI
//   // -----------------------------------------------------
//   return (
//     <div className="fixed bottom-6 right-6 z-[99999] flex flex-col items-end gap-3">
//       {isOpen && (
//         <div className="w-96 h-96 bg-white dark:bg-slate-900 rounded-2xl shadow-xl border overflow-hidden flex flex-col">
//           <div className="flex items-center justify-between p-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
//             <h3 className="font-semibold text-sm text-white">AI Suggestions</h3>
//             <button
//               onClick={() => setIsOpen(false)}
//               className="hover:bg-white/10 p-1 rounded-lg"
//             >
//               <FaTimes className="w-4 h-4" />
//             </button>
//           </div>

//           <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-slate-50 to-white dark:bg-slate-900 dark:to-slate-800">
//             {messages.length === 0 && !isTyping ? (
//               <div className="flex justify-center items-center h-full text-slate-400">
//                 Fill the form to see AI suggestions.
//               </div>
//             ) : (
//               <>
//                 {messages
//                   .filter((msg) => msg && msg.content && msg.field) // remove invalid messages
//                   .map((msg) => (
//                     <div key={msg.id}>
//                       <div className="flex gap-2 mb-1 items-center">
//                         <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
//                           AI
//                         </div>
//                         <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
//                           {msg.field}
//                         </span>
//                       </div>

//                       <div className="ml-8 p-3 rounded-xl bg-white dark:bg-slate-800 border text-sm whitespace-pre-wrap">
//                         {msg.content}
//                       </div>
//                     </div>
//                   ))}


//                 {isTyping && (
//                   <div>
//                     <div className="flex gap-2 mb-1 items-center">
//                       <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
//                         AI
//                       </div>
//                       <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
//                         <div className="p-2 rounded-xl border dark:bg-slate-800 flex gap-1">
//                           <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce" />
//                           <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce delay-150" />
//                           <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce delay-300" />
//                         </div>
//                       </span>
//                     </div>
//                   </div>
//                 )}

//                 <div ref={messagesEndRef} />
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       <button
//         onClick={handleOpen}
//         className={`relative w-16 h-16 rounded-full flex items-center justify-center shadow-xl transition ${isOpen
//             ? "bg-gradient-to-br from-indigo-500 to-purple-500"
//             : "bg-gradient-to-br from-indigo-600 to-purple-600"
//           }`}
//       >
//         <FaRobot className="w-7 h-7 text-white" />

//         {hasNewNotification && !isOpen && (
//           <span className="absolute top-2 right-2 w-3 h-3 rounded-full bg-red-500 animate-ping" />
//         )}
//       </button>
//     </div>
//   );
// }









import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { FaTimes, FaRobot } from "react-icons/fa";
import { useTypedSelector } from "@/hooks";
import {
  useFetchAISuggestionMessagesQuery,
  usePostCompaRatioReviewMutation,
  usePostCriticalPayPositioningMutation,
  usePostPaymentRecommendationMutation,
  usePostRetentionRiskMutation,
  usePostHireConversionAnalysisMutation,
} from "@/services/aiSuggestion2";
import { getSelectedCompanyFromStorage } from "@/services/cookies";

export function AISuggestionBot() {
  const offerModellerData = useTypedSelector((state) => state.offers);

  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [hasNewNotification, setHasNewNotification] = useState(false);
  const [insightsLoaded, setInsightsLoaded] = useState(false);

  const [initialParams, setInitialParams] = useState(null);
  const [conversionCalled, setConversionCalled] = useState(false);

  const messagesEndRef = useRef(null);

  const scrollToBottom = ({ behavior = "smooth" }) =>
    messagesEndRef.current?.scrollIntoView({ behavior });

  const company_id = getSelectedCompanyFromStorage();
  const offer_id = offerModellerData?.offer?.id;

  // -----------------------------------------------------
  // Extract offer modeller values
  // -----------------------------------------------------
  const offer_fixed_cash = offerModellerData?.offerModeller?.offer_fixed_cash;
  const offer_sti = offerModellerData?.offerModeller?.offer_sti;
  const offer_lti = offerModellerData?.offerModeller?.offer_lti;

  const compa_ratio = offer_fixed_cash?.proposed_compa_ratio ?? 0;
  const market_ratio = offer_fixed_cash?.proposed_market_ratio ?? 0;

  const current_guaranteed_cash = offer_fixed_cash?.current_total ?? 0;
  const proposed_guaranteed_cash = offer_fixed_cash?.proposed_total ?? 0;

  const current_unvested_equity = offer_lti?.current_unvested_equity ?? 0;

  const current_total_target_cash =
    (offer_fixed_cash?.current_total || 0) +
    (offer_sti?.current_total_bonus || 0);

    console.log({compa_ratio,market_ratio,current_guaranteed_cash,proposed_guaranteed_cash,current_unvested_equity,current_total_target_cash})

  // -----------------------------------------------------
  // PATCH #1: useMemo for heavy calculation
  // -----------------------------------------------------
  const proposed_total_target_cash = useMemo(() => {
    return Math.round(
      offer_sti?.is_sale_incentive &&
        offer_fixed_cash?.proposed_annual_base &&
        offer_sti?.proposed_base_pay_percentage
        ? (offer_fixed_cash.proposed_annual_base *
          ((offer_fixed_cash.proposed_annual_base *
            (100 - offer_sti.proposed_base_pay_percentage)) /
            100)) /
        ((offer_fixed_cash.proposed_annual_base *
          offer_sti.proposed_base_pay_percentage) /
          100) -
        offer_sti.proposed_base_pay_percentage +
        ((offer_sti?.proposed_total_bonus || 0) +
          (offer_fixed_cash?.proposed_total || 0))
        : (offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0)
    );
  }, [offer_sti, offer_fixed_cash]);

  // -----------------------------------------------------
  // INSIGHTS API
  // -----------------------------------------------------
  const { data: insightsData, isFetching: isFetchingInsights } =
    useFetchAISuggestionMessagesQuery(
      { company_id, offer_id },
      { skip: !company_id || !offer_id }
    );

  // -----------------------------------------------------
  // MUTATIONS
  // -----------------------------------------------------
  // -----------------------------------------------------
  // MUTATIONS
  // -----------------------------------------------------
  const [
    triggerCompaRatio,
    { data: compaData, isLoading: isFetchingCompa }
  ] = usePostCompaRatioReviewMutation();

  const [
    triggerCriticalPay,
    { data: criticalData, isLoading: isFetchingCritical }
  ] = usePostCriticalPayPositioningMutation();

  const [
    triggerPaymentRecommendation,
    { data: paymentData, isLoading: isFetchingPayment }
  ] = usePostPaymentRecommendationMutation();

  const [
    triggerRetentionRisk,
    { data: retentionData, isLoading: isFetchingRetention }
  ] = usePostRetentionRiskMutation();

  const [
    triggerConversionAnalysis,
    { data: conversionData, isLoading: isFetchingConversion }
  ] = usePostHireConversionAnalysisMutation();


  // -----------------------------------------------------
  // Capture initial params ONCE
  // -----------------------------------------------------
  useEffect(() => {
    if (
      !initialParams &&
      compa_ratio != null &&
      market_ratio != null &&
      current_unvested_equity != null &&
      current_total_target_cash != null &&
      proposed_total_target_cash != null &&
      current_guaranteed_cash != null &&
      proposed_guaranteed_cash != null
    ) {
      setInitialParams({
        compa_ratio,
        market_ratio,
        current_unvested_equity,
        current_total_target_cash,
        proposed_total_target_cash,
        current_guaranteed_cash,
        proposed_guaranteed_cash,
      });
    }
  }, [
    initialParams,
    compa_ratio,
    market_ratio,
    current_unvested_equity,
    current_total_target_cash,
    proposed_total_target_cash,
    current_guaranteed_cash,
    proposed_guaranteed_cash,
  ]);

  // -----------------------------------------------------
  // LOAD INSIGHTS ONCE
  // -----------------------------------------------------
  useEffect(() => {
    if (!insightsLoaded && insightsData?.data?.insights?.length > 0) {
      const mapped = insightsData.data.insights.map((insight) => ({
        id: `insight-${insight.id}`,
        field: insight.alert_type?.replace(/_/g, " "),
        content: insight.message,
        timestamp: new Date(insight.created_at).getTime(),
      }));

      setMessages((prev) => [...prev, ...mapped]);

      if (!isOpen) setHasNewNotification(true);

      setInsightsLoaded(true);
    }
  }, [insightsData]);

  const initialLoadComplete = Boolean(initialParams || insightsLoaded);

  // -----------------------------------------------------
  // TRIGGER CONVERSION ANALYSIS ONCE
  // -----------------------------------------------------
  useEffect(() => {
    if (insightsLoaded && !conversionCalled) {
      triggerConversionAnalysis({ company_id, offer_id });
      setConversionCalled(true);
    }
  }, [insightsLoaded, conversionCalled]);

  // -----------------------------------------------------
  // PARAM CHANGE DETECTORS
  // -----------------------------------------------------
  const compaChanged =
    initialLoadComplete &&
    (
      compa_ratio !== initialParams?.compa_ratio ||
      market_ratio !== initialParams?.market_ratio
    );

  const paymentChanged =
    initialLoadComplete &&
    (
      current_unvested_equity !== initialParams?.current_unvested_equity ||
      current_total_target_cash !== initialParams?.current_total_target_cash ||
      proposed_total_target_cash !== initialParams?.proposed_total_target_cash
    );

  const retentionChanged =
    initialLoadComplete &&
    (
      current_total_target_cash !== initialParams?.current_total_target_cash ||
      proposed_total_target_cash !== initialParams?.proposed_total_target_cash ||
      current_guaranteed_cash !== initialParams?.current_guaranteed_cash ||
      proposed_guaranteed_cash !== initialParams?.proposed_guaranteed_cash
    );

  // -----------------------------------------------------
  // PATCH #2: Unified Parameter Change Orchestrator
  // -----------------------------------------------------
  useEffect(() => {
    if (!initialLoadComplete) return;

    const actions = [];

    // COMPA + CRITICAL
    if (compaChanged) {
      actions.push(() =>
        triggerCompaRatio({ company_id, offer_id, compa_ratio, market_ratio })
      );

      actions.push(() =>
        triggerCriticalPay({ company_id, offer_id, compa_ratio, market_ratio })
      );
    }

    // PAYMENT
    if (paymentChanged) {
      actions.push(() =>
        triggerPaymentRecommendation({
          company_id,
          offer_id,
          current_unvested_equity,
          current_total_target_cash,
          proposed_total_target_cash,
        })
      );
    }

    // RETENTION
    if (retentionChanged) {
      actions.push(() =>
        triggerRetentionRisk({
          company_id,
          offer_id,
          current_total_target_cash,
          proposed_total_target_cash,
          current_guaranteed_cash,
          proposed_guaranteed_cash,
        })
      );
    }

    if (actions.length === 0) return;

    const timer = setTimeout(() => {
      actions.forEach((fn) => fn());
    }, 600);

    return () => clearTimeout(timer);
  }, [
    compaChanged,
    paymentChanged,
    retentionChanged,
    initialLoadComplete,
    compa_ratio,
    market_ratio,
    current_unvested_equity,
    current_total_target_cash,
    proposed_total_target_cash,
    current_guaranteed_cash,
    proposed_guaranteed_cash
  ]);

  // -----------------------------------------------------
  // APPEND RESULTS FOR ALL API TYPES
  // -----------------------------------------------------
  const append = useCallback(
    (api, prefix) => {
      if (!api?.data) return;

      const field = api.data.alert_type?.replace(/_/g, " ") || prefix;
      const msg = api.data.message?.trim();

      if (!msg) return;

      setMessages((prev) => [
        ...prev,
        {
          id: `${prefix}-${Date.now()}`,
          field,
          content: msg,
          timestamp: Date.now(),
        },
      ]);

      if (!isOpen) setHasNewNotification(true);
    },
    [isOpen]
  );

  useEffect(() => append(compaData, "compa"), [compaData]);
  useEffect(() => append(criticalData, "critical"), [criticalData]);
  useEffect(() => append(paymentData, "payment"), [paymentData]);
  useEffect(() => append(retentionData, "retention"), [retentionData]);
  useEffect(() => append(conversionData, "conversion"), [conversionData]);

  // -----------------------------------------------------
  // AUTO SCROLL
  // -----------------------------------------------------
  useEffect(() => {
    scrollToBottom({ behavior: "smooth" });
  }, [
    messages,
    isFetchingInsights,
    compaData,
    criticalData,
    paymentData,
    retentionData,
    conversionData,
  ]);

  useEffect(function scrollToBottomAuto() {
    scrollToBottom({ behavior: "auto" })
  }, [isOpen])

  // -----------------------------------------------------
  // EXTERNAL ADD MESSAGE
  // -----------------------------------------------------
  const handleAddSuggestion = useCallback(
    (field, content) => {
      if (!content || !field) return;

      setMessages((prev) => [
        ...prev,
        {
          id: `msg-${Date.now()}`,
          field,
          content,
          timestamp: Date.now(),
        },
      ]);

      if (!isOpen) setHasNewNotification(true);
    },
    [isOpen]
  );

  useEffect(() => {
    window.__chatbotSuggestion = handleAddSuggestion;
  }, [handleAddSuggestion]);

  // -----------------------------------------------------
  // UI OPEN/CLOSE
  // -----------------------------------------------------
  const handleOpen = () => {
    setIsOpen((prev) => !prev);
    setHasNewNotification(false);
  };

  const isTyping =
    isFetchingInsights ||
    isFetchingCompa ||
    isFetchingCritical ||
    isFetchingPayment ||
    isFetchingRetention ||
    isFetchingConversion;


  // -----------------------------------------------------
  // UI
  // -----------------------------------------------------

  return (
    <div className="fixed bottom-6 right-6 z-[99999] flex flex-col items-end gap-3">

      {isOpen && (
        <div className="w-96 h-96 bg-white dark:bg-slate-900 rounded-2xl shadow-xl border overflow-hidden flex flex-col">

          <div className="flex items-center justify-between p-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
            <h3 className="font-semibold text-sm">AI Suggestions</h3>
            <button onClick={() => setIsOpen(false)} className="hover:bg-white/10 p-1 rounded-lg">
              <FaTimes className="w-4 h-4" />
            </button>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-slate-50 to-white dark:from-slate-900 dark:to-slate-800">

            {messages.length === 0 && !isTyping ? (
              <div className="flex justify-center items-center h-full text-slate-400">
                Fill the form to see AI suggestions.
              </div>
            ) : (
              <>
                {messages
                  .filter((msg) => msg && msg.content && msg.field)
                  .map((msg) => (
                    <div key={msg.id}>
                      <div className="flex gap-2 mb-1 items-center">
                        <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
                          AI
                        </div>
                        <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
                          {msg.field}
                        </span>
                      </div>

                      <div className="ml-8 p-3 rounded-xl bg-white dark:bg-slate-800 border text-sm whitespace-pre-wrap">
                        {msg.content}
                      </div>
                    </div>
                  ))}

                {isTyping && (
                  <div className="flex gap-2 mb-1 items-center">
                    <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center text-white text-xs font-bold">
                      AI
                    </div>
                    <span className="text-[10px] px-2 py-1 rounded-full bg-indigo-100 text-indigo-700">
                      <div className="p-2 rounded-xl border dark:bg-slate-800 flex gap-1">
                        <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce"></span>
                        <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce delay-150"></span>
                        <span className="w-2 h-2 bg-indigo-200 rounded-full animate-bounce delay-300"></span>
                      </div>
                    </span>
                  </div>
                )}

                <div ref={messagesEndRef} />
              </>
            )}
          </div>
        </div>
      )}

      <button
        onClick={handleOpen}
        className={`relative w-16 h-16 rounded-full flex items-center justify-center shadow-xl transition ${isOpen
          ? "bg-gradient-to-br from-indigo-500 to-purple-500"
          : "bg-gradient-to-br from-indigo-600 to-purple-600"
          }`}
      >
        <FaRobot className="w-7 h-7 text-white" />

        {hasNewNotification && !isOpen && (
          <span className="absolute top-2 right-2 w-3 h-3 rounded-full bg-red-500 animate-ping" />
        )}
      </button>

    </div>
  );
}



